<div>
  <ng-content></ng-content>
  <vitamui-common-scroll-top></vitamui-common-scroll-top>
</div>
